import {
  getReports,
  getReport,
  deleteReport
} from '@/services/reportApi'

export const fetchReports = async ({ commit }, { orgId }) => {
  console.log('Fetching reports for org:', orgId)

  try {
    const response = await getReports(orgId)

    // Add each report to the store
    response.reports.forEach(report => {
      commit('SET_REPORT', { orgId, report })
    })

    return response.reports
  } catch (error) {
    console.error('Failed to fetch reports:', error)
    throw error
  }
}

export const fetchReport = async ({ commit }, { orgId, reportUuid, version = null }) => {
  console.log('Fetching report:', reportUuid, 'version:', version)

  try {
    const report = await getReport(orgId, reportUuid, version)
    commit('SET_REPORT', { orgId, report })
    return report
  } catch (error) {
    console.error('Failed to fetch report:', error)
    throw error
  }
}

export const deleteReportAction = async ({ commit }, { orgId, reportUuid }) => {
  console.log('Deleting report:', reportUuid)

  try {
    await deleteReport(orgId, reportUuid)
    commit('DELETE_REPORT', { orgId, reportUuid })
  } catch (error) {
    console.error('Failed to delete report:', error)
    throw error
  }
}

export const setActiveReport = ({ commit }, reportUuid) => {
  commit('SET_ACTIVE_REPORT', reportUuid)
}

export const setActiveVersion = ({ commit }, version) => {
  commit('SET_ACTIVE_VERSION', version)
}

export const clearReportData = ({ commit }) => {
  commit('CLEAR_REPORT_DATA')
}

export const updateReport = ({ commit }, { orgId, report }) => {
  commit('SET_REPORT', { orgId, report })
}
